/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CheckRequirements/Requirement/Task/Content/Basket/Error"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtTysiainputlabelColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputLabel.color.primary.base'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Error.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-4QcjJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Task Basket"
 color={dtTysiainputlabelColorPrimaryBase}
 fontFamily="Inter"
 weight="semibold"
 whiteSpace="nowrap"
 overflowX="hidden"
 textOverflow="ellipsis"
 marginBottom={dtSpaceXs}
 size="medium"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Something went wrong"
/>
</div>
{children}
</React.Fragment>)
}